import { Chip, Stack } from '@mui/material';
import React from 'react';
import { dueLabel } from './queue';

/** The Expected column: when the bill is due, plus a Late chip once it is past the late threshold (LB-6032). */
export const DueCell = _ref => {
  let row = _ref.row;
  return (
    /*#__PURE__*/
    // Wraps as whole chips: squeezed side by side, the due label broke onto two lines.
    React.createElement(Stack, {
      direction: "row",
      gap: "4px",
      alignItems: "center",
      flexWrap: "wrap",
      sx: {
        paddingY: '6px'
      }
    }, /*#__PURE__*/React.createElement(Chip, {
      size: "small",
      label: dueLabel(row),
      color: row.isOverdue ? 'warning' : 'default',
      sx: {
        flexShrink: 0
      }
    }), row.isLate ? /*#__PURE__*/React.createElement(Chip, {
      size: "small",
      label: "Late",
      color: "error",
      sx: {
        flexShrink: 0
      }
    }) : null)
  );
};